let routes = [
  {
    // 检查记录
    path: '/Check',
    name: 'Check',
    component: () => import('@/views/Record/CheckRecord/Check/Check'), //检查记录'
    meta: {
      title: '检查记录',
    }
  }, {
    // 检查记录详情
    path: '/CheckInfo',
    name: 'CheckInfo',
    component: () => import('@/views/Record/CheckRecord/CheckInfo/CheckInfo'), //检查记录详情'
    meta: {
      title: '检查记录详情',
    }
  }, {
    // 就医记录详情
    path: '/HospitalizeInfo',
    name: 'HospitalizeInfo',
    component: () => import('@/views/Record/HospitalizeRecord/HospitalizeInfo/info'), //就医记录详情'
    meta: {
      title: '就医记录详情',
    }
  }, {
    // 就医记录
    path: '/Hospitalize',
    name: 'Hospitalize',
    component: () => import('@/views/Record/HospitalizeRecord/Hospitalize/Hospitalize'), //就医记录'
    meta: {
      title: '就医记录',
    }
  }, {
    // 干预记录
    path: '/Interfere',
    name: 'Interfere',
    component: () => import('@/views/Record/InterfereRecord/Interfere/index'), //干预记录'
    meta: {
      title: '干预记录',
    }
  },

  {
    path: '/InterfereStatistics',
    component: () => import('@/views/Record/InterfereStatistics/InterfereStatistics'),
    meta: {
      title: '干预统计',
    },
  },


  {
    path: '/useDrugRecord',
    component: () => import('@/views/useDrugRecord/useDrugRecord'),
    meta: {
      title: '用药记录',
    }
  },
  {
    path: '/useDrugRecordHandle',
    component: () => import('@/views/useDrugRecord/modules/useDrugHandle'),
    meta: {
      title: '添加用药记录',
    },
  },
  {
    path: '/healthService',
    component: () => import('@/views/healthService/healthService'),
    meta: {
      title: '健康服务',
    },
  },
  {
    path: '/reservationHealthService',
    component: () => import('@/views/healthService/modules/reservationHealthService'),
    meta: {
      title: '预约服务',
    },
  },
  {
    path: '/success',
    component: () => import('@/views/healthService/modules/success'),
    meta: {
      title: '预约成功',
    },
  },
  {
  	// 服务记录
  	path: '/RecordList',
  	name: 'RecordList',
  	component: () => import('@/views/Record/ServiceRecord/index'), //服务记录'
  	meta: {
  		title: '服务记录',
  	}
  },
  {
  	// 已过期服务
  	path: '/healthout',
  	name: 'healthout',
  	component: () => import('@/views/healthService/healthout'),
  	meta: {
  		title: '过期服务',
  	}
  },
  {
  	// 运动方案
  	path: '/SportsRecordList',
  	name: 'SportsRecordList',
  	component: () => import('@/views/Record/SportsRecord/SportsRecordList'),
  	meta: {
  		title: '运动方案',
  	}
  },
  {
  	// 运动方案详情
  	path: '/SportsRecordDetail',
  	name: 'SportsRecordDetail',

    // 进行暂时的修改
  	component: () => import('@/views/Record/SportsRecord/SportsRecordDetail'),
  	meta: {
  		title: '运动方案详情',
  	}
  },
  {
  	// 具体的应用
  	path: '/SportsItemDetail',
  	name: 'SportsItemDetail',
  	component: () => import('@/views/Record/SportsRecord/SportsItemDetail'),
  	meta: {
  		title: '具体的运动',
  	}
  },
  {
  	// 膳食方案
  	path: '/MealHealthList',
  	name: 'MealHealthList',
  	component: () => import('@/views/Record/MealHealth/MealHeathList'),
  	meta: {
  		title: '膳食方案',
  	}
  },
  {
  	// 膳食方案详情
  	path: '/MealHeal',
  	name: 'MealHeal',
    //好像这里触碰到了隐藏字段所以这里用小写来代替
  	component: () => import('@/views/Record/MealHealth/mealheal'),
  	meta: {
  		title: '膳食方案详情',
  	}
  },
  {
  	// 具体的菜品
  	path: '/MealItemDetail',
  	name: 'MealItemDetail',
  	component: () => import('@/views/Record/MealHealth/MealItemDetail'),
  	meta: {
  		title: '具体的菜品',
  	}
  },


];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routerPage/Record.js